/* eslint-disable */
// GENERADO por `yarn workspace psiplatform-be activity:catalog` desde el catálogo del backend
// (psiplatform-be/src/modules/activity/activity.catalog.ts). NO editar a mano: un test del backend falla si
// este archivo no coincide con el catálogo. Lo usan el tipo de `trackAction` y el test de cobertura del frontend.

export const ACTIVITY_ACTIONS = [
  { key: "search_patients_agenda", instrumentation: "instrumented", deprecated: false },
  { key: "search_patients_list", instrumentation: "instrumented", deprecated: false },
  { key: "assistant_question_sent", instrumentation: "instrumented", deprecated: false },
  { key: "home_article_opened", instrumentation: "instrumented", deprecated: false },
  { key: "kb_search_used", instrumentation: "instrumented", deprecated: false },
  { key: "session_booking_started", instrumentation: "instrumented", deprecated: false },
  { key: "session_booked", instrumentation: "instrumented", deprecated: false },
  { key: "clinical_note_opened", instrumentation: "instrumented", deprecated: false },
  { key: "clinical_note_saved", instrumentation: "instrumented", deprecated: false },
  { key: "availability_edit_started", instrumentation: "instrumented", deprecated: false },
  { key: "availability_saved", instrumentation: "instrumented", deprecated: false },
  { key: "payment_info_opened", instrumentation: "instrumented", deprecated: false },
  { key: "payment_info_edited", instrumentation: "instrumented", deprecated: false },
  { key: "payment_info_saved", instrumentation: "instrumented", deprecated: false },
  { key: "vacation_requested", instrumentation: "instrumented", deprecated: false },
  { key: "vacation_confirmed", instrumentation: "instrumented", deprecated: false },
  { key: "no_schedule_opened", instrumentation: "instrumented", deprecated: false },
  { key: "no_schedule_submitted", instrumentation: "instrumented", deprecated: false },
  { key: "derivation_submitted", instrumentation: "instrumented", deprecated: false },
  { key: "baja_started", instrumentation: "instrumented", deprecated: false },
  { key: "baja_completed", instrumentation: "instrumented", deprecated: false },
  { key: "journey_resource_accepted", instrumentation: "instrumented", deprecated: false },
  { key: "comunidad_calendar_viewed", instrumentation: "instrumented", deprecated: false },
  { key: "comunidad_enrollment", instrumentation: "instrumented", deprecated: false },
  { key: "comunidad_certificado_descargado", instrumentation: "instrumented", deprecated: false },
  { key: "comunidad_certificado_linkedin", instrumentation: "instrumented", deprecated: false },
  { key: "feriado_bloquear", instrumentation: "instrumented", deprecated: false },
  { key: "feriado_voy_a_trabajar", instrumentation: "instrumented", deprecated: false },
  { key: "feriado_sesiones_vistas", instrumentation: "instrumented", deprecated: false },
  { key: "gcal_connect_started", instrumentation: "instrumented", deprecated: false },
  { key: "gcal_connected", instrumentation: "instrumented", deprecated: false },
  { key: "notification_link_clicked", instrumentation: "instrumented", deprecated: false },
  { key: "session_cancelled", instrumentation: "instrumented", deprecated: false },
  { key: "session_rescheduled", instrumentation: "instrumented", deprecated: false },
  { key: "absence_reported", instrumentation: "instrumented", deprecated: false },
  { key: "meet_opened", instrumentation: "instrumented", deprecated: false },
  { key: "patient_marked_urgent", instrumentation: "instrumented", deprecated: false },
  { key: "patient_limit_changed", instrumentation: "instrumented", deprecated: false },
  { key: "advance_payment_requested", instrumentation: "instrumented", deprecated: false },
  { key: "profile_attention_saved", instrumentation: "instrumented", deprecated: false },
] as const;
export type ActivityActionKey = (typeof ACTIVITY_ACTIONS)[number]["key"];

export const ACTIVITY_SCREENS = [
  { key: "home", deprecated: false },
  { key: "sessions", deprecated: false },
  { key: "sessions.meet", deprecated: true },
  { key: "meet", deprecated: false },
  { key: "calendar.semanal", deprecated: false },
  { key: "calendar.mensual", deprecated: false },
  { key: "calendar.diaria", deprecated: false },
  { key: "calendar.time-off", deprecated: true },
  { key: "camino-inicial", deprecated: false },
  { key: "patients.todos", deprecated: false },
  { key: "patients.nuevos", deprecated: false },
  { key: "patients.activos", deprecated: false },
  { key: "patients.en-pausa", deprecated: false },
  { key: "patients.inactivos", deprecated: false },
  { key: "patients.derivacion-exitosa", deprecated: false },
  { key: "patients.derivation", deprecated: false },
  { key: "patients.no-schedule", deprecated: true },
  { key: "profile.general", deprecated: false },
  { key: "profile.atencion", deprecated: false },
  { key: "profile.vacaciones", deprecated: false },
  { key: "profile.estilo-terapeutico", deprecated: false },
  { key: "profile.farewell", deprecated: false },
  { key: "profile.metricas.resumen", deprecated: false },
  { key: "profile.metricas.inactividad", deprecated: false },
  { key: "profile.metricas.asignacion", deprecated: false },
  { key: "profile.metricas.asignacion-inicial", deprecated: false },
  { key: "profile.metricas.psi-plus", deprecated: false },
  { key: "profile.metricas.liquidacion", deprecated: false },
  { key: "profile.metricas.liquidacion.info", deprecated: false },
  { key: "profile.metricas.liquidacion.pago", deprecated: false },
  { key: "profile.metricas.psi-plus.bono-500", deprecated: false },
  { key: "profile.metricas.psi-plus.bonos-1000-2000", deprecated: false },
  { key: "profile.metricas.psi-plus.historial", deprecated: false },
  { key: "profile.metricas.asignacion.hub", deprecated: false },
  { key: "profile.metricas.asignacion.concept", deprecated: false },
  { key: "profile.metricas.asignacion.blocks", deprecated: false },
  { key: "profile.metricas.asignacion.cupo", deprecated: false },
  { key: "profile.metricas.asignacion.horarios", deprecated: false },
  { key: "profile.metricas.asignacion.reprogramacion", deprecated: false },
  { key: "profile.metricas.asignacion.inactividad", deprecated: false },
  { key: "profile.metricas.inactividad.proceso", deprecated: false },
  { key: "profile.metricas.inactividad.porque", deprecated: false },
  { key: "profile.metricas.inactividad.concordancia", deprecated: false },
  { key: "profile.metricas.inactividad.exclusiones", deprecated: false },
  { key: "profile.metricas.inactividad.universo", deprecated: false },
  { key: "profile.metricas.inactividad.bajas", deprecated: false },
  { key: "profile.metricas.inactividad.excluidos", deprecated: false },
  { key: "profile.metricas.inactividad.todos", deprecated: false },
  { key: "profile.metricas.inactividad.objetivo", deprecated: false },
  { key: "profile.metricas.asignacion-inicial.proceso", deprecated: false },
  { key: "profile.metricas.asignacion-inicial.adherencia", deprecated: false },
  { key: "profile.metricas.asignacion-inicial.horarios", deprecated: false },
  { key: "comunidad", deprecated: false },
  { key: "comunidad.admin", deprecated: false },
  { key: "comunidad.newsletter", deprecated: false },
  { key: "comunidad.novedades", deprecated: false },
  { key: "unmapped", deprecated: false },
] as const;
export type ActivityScreenKey = (typeof ACTIVITY_SCREENS)[number]["key"];

/** Pathnames exactos (rutas sin parámetros) → screen_key. Sale de `paths` de cada pantalla del catálogo. */
export const ACTIVITY_STATIC_ROUTES: Readonly<Record<string, string>> = {
  "/home": "home",
  "/sessions": "sessions",
  "/sessions/meet": "sessions.meet",
  "/calendar": "calendar.semanal",
  "/calendar/time-off": "calendar.time-off",
  "/camino-inicial": "camino-inicial",
  "/patients": "patients.todos",
  "/patients/derivation": "patients.derivation",
  "/patients/no-schedule": "patients.no-schedule",
  "/profile": "profile.general",
  "/profile/farewell": "profile.farewell",
  "/profile/metricas": "profile.metricas.resumen",
  "/comunidad": "comunidad",
  "/comunidad/admin": "comunidad.admin",
  "/comunidad/newsletter": "comunidad.newsletter",
};
